import React from 'react'
import PropTypes from 'prop-types'
import useQueryCachedThenPollNetwork from 'lib/hooks/useQueryCachedThenPollNetwork'

import getInboxMessageCount from 'graphql/navigation/getInboxMessageCount.gql'

const inboxPollInterval = 1000 * 60 * 5 // 5 minutes

const Authed = ({ children }) => {
    const { data } = useQueryCachedThenPollNetwork(getInboxMessageCount, { pollInterval: inboxPollInterval })
    const { unreadMessageCount } = data || {}
    return children({ unreadMessageCount: (unreadMessageCount && unreadMessageCount > 0) ? unreadMessageCount : 0 })
}
const NotAuthed = ({ children }) => children({})

const AppHeaderInboxLogic = ({ children, loggedIn }) => {
    const HeaderAuthLogic = loggedIn ? Authed : NotAuthed

    return (
        <HeaderAuthLogic>
            {(props) => children(props)}
        </HeaderAuthLogic>
    )
}

AppHeaderInboxLogic.propTypes = {
    loggedIn: PropTypes.bool.isRequired,
}

export default AppHeaderInboxLogic
